<form [formGroup]="form"
  (submit)="onComplete()"
  class="bb-block">

  <div class="bn-transaction-signing-widget__content">
    <div class="bn-transaction-signing-widget__content__inner">
      <div class="form-group bn-transaction-signing-widget__block">
        <bb-input-text-ui data-role="ts-sms-otp-field"
          class="bb-form-field h5"
          formControlName="otp"
          i18n-label="Aria label for otp field input@@bb-sms-otp-signing.label"
          label="Enter your verification code"
          [maxLength]="expectedOtpLength"
          [minLength]="expectedOtpLength">
        </bb-input-text-ui>

        <div>
          <bn-otp-error-msg [displayError]="data?.error"
            [errorMesssageComplement]="errorComplement"
            [errorCode]="errorCode"></bn-otp-error-msg>
        </div>


        <bb-alert-ui *ngIf="displayMissingAlert"
          data-role="ts-sms-otp-missing-alert"
          i18n-title="No value alert title for sms otp signing@@bb-sms-otp-signing.alert.missing.title"
          title="No value entered">
          <span i18n="No value alert message for sms otp signing@@bb-sms-otp-signing.alert.missing.message">
            Please enter the value displayed on your device.
          </span>
        </bb-alert-ui>
        <bb-alert-ui *ngIf="displayIncorrectAlert"
          data-role="ts-sms-otp-incorrect-alert"
          i18n-title="Incorrect attempts alert title for sms otp signing@@bb-sms-otp-signing.alert.incorrect.title">
          <span i18n="@bb-sms-otp-signing.alert.incorrect.message-banesco">
            Incorrect code, please try again.
          </span>
        </bb-alert-ui>
        <bb-alert-ui *ngIf="displayRemainingAlert"
          data-role="ts-sms-otp-remaining-alert"
          i18n-title="Remaining attempts alert title for sms otp signing@@bb-sms-otp-signing.alert.remaining.title">
          <span i18n="Remaining attempts alert message for sms otp signing@@bb-sms-otp-signing.alert.remaining.message">
            Incorrect code, please try again. <br>
            You have {{0}} other {4, plural,
            =1
            {attempt} other {attempts}} remaining.
          </span>
        </bb-alert-ui>
        <bb-alert-ui *ngIf="isResend"
          data-role="ts-sms-otp-resend-alert"
          modifier="info"
          class="purple-alert">
          <span i18n="@bb-sms-otp-signing.alert.resent.message-sent">
            Code sent! Wait for it to arrive.
          </span>
        </bb-alert-ui>
      </div>

      <p *ngIf="displayResendLink">
        <span i18n="@@bb-sms-otp-signing.did-not-receive-code">If you haven't received the text message, try again by
          clicking</span>
        <a i18n="@@bb-sms-otp-signing.resend"
          class="bn-transaction-signing-widget__link"
          (click)="onResend()"> Resend
        </a>
        <span i18n="@@bb-sms-otp-signing.contact-us-at"> or please contact us at:</span>
      </p>

      <p *ngIf="!displayResendLink">
        <span i18n="@@bb-sms-otp-signing.code-not-received-contact-us-at">
          You have reached the maximum number of attempts (3) to enter your verification code. Close this window and
          start the
          process again.
        </span>
      </p>

      <ul *ngIf="displayResendLink">
        <li>
          <span i18n="@@bb-sms-otp-signing.main">Main </span>
          <b class="font-weight-bold small"> 829-893-8200</b>
        </li>
        <li>
          <span i18n="@@bb-sms-otp-signing.dominican-republic-number">Dominican Republic toll free</span>
          <b class="font-weight-bold small"> 1-809-200-1101</b>
        </li>
        <li>
          <span i18n="@@bb-sms-otp-signing.whatsapp">Whatsapp </span>
          <b class="font-weight-bold small"> 829-647-8100</b>
        </li>
      </ul>
    </div>
  </div>


  <hr>

  <div class="bb-button-bar">
    <button bbButton
      data-role="ts-sms-otp-complete"
      class="bb-button-bar__button"
      color="primary"
      type="submit"
      i18n="Complete button@@bb-sms-otp-signing.complete">
      Complete
    </button>
    <button bbButton
      data-role="ts-sms-otp-cancel"
      class="bb-button-bar__button"
      color="secondary"
      i18n="@@contact-manager.banesco-form.cancel"
      (click)="onCancel()">
      Cancel
    </button>
  </div>
</form>

<div style="display:none">
  <div i18n="@@otp-validation-please-wait">Please wait</div>
  <div i18n="@@otp-validation-seconds">seconds and try again</div>
</div>